var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlcoholSvgrepoCom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Food_Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 47.206 114.803",
    enableBackground: "new 0 0 47.206 114.803",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x36_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9AC97F",
    d: "M45.265,58.389l0.002,49.767c0,2.603-2.105,4.708-4.708,4.708H6.649c-2.592,0-4.708-2.105-4.708-4.708 L1.938,58.389c0-8.829,5.65-16.352,13.527-19.143V16.202h16.273v23.043C39.615,42.037,45.265,49.559,45.265,58.389z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#AB5063",
    d: "M45.294,58.674l0.002,49.767c0,2.603-2.105,4.708-4.708,4.708H6.677c-2.592,0-4.708-2.105-4.708-4.708 L1.967,57.46C8.344,63.837,39.355,52.736,45.294,58.674z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M39.233,58.389l0.002,49.767c0,2.603-2.105,4.708-4.708,4.708H6.649c-2.592,0-4.708-2.105-4.708-4.708 L1.938,58.389c0-8.829,5.65-16.352,13.527-19.143V16.202h10.241v23.043C33.583,42.037,39.233,49.559,39.233,58.389z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.558,114.803H6.648c-3.665,0-6.647-2.982-6.647-6.647L0,58.388c0-8.938,5.381-16.995,13.527-20.467V14.263h20.15 v23.657c8.145,3.473,13.527,11.53,13.527,20.467l0.002,49.767C47.206,111.821,44.224,114.803,40.558,114.803z M17.404,18.141 v22.474l-1.291,0.458C8.795,43.666,3.877,50.625,3.877,58.388l0.001,49.767c0,1.527,1.242,2.77,2.77,2.77h33.91 c1.528,0,2.77-1.243,2.77-2.77l-0.002-49.767c0-7.764-4.917-14.722-12.236-17.316l-1.291-0.458V18.141H17.404z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.23,
    y: 9.001,
    fill: "#F3E5E5",
    width: 20.745,
    height: 8.309
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.975,19.249H13.23c-1.071,0-1.939-0.868-1.939-1.939V9.001c0-1.071,0.868-1.939,1.939-1.939h20.745 c1.071,0,1.939,0.868,1.939,1.939v8.309C35.914,18.381,35.046,19.249,33.975,19.249z M15.169,15.371h16.868V10.94H15.169V15.371z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.975,19.249H13.23c-1.071,0-1.939-0.868-1.939-1.939V9.001c0-1.071,0.868-1.939,1.939-1.939h20.745 c1.071,0,1.939,0.868,1.939,1.939v8.309C35.914,18.381,35.046,19.249,33.975,19.249z M15.169,15.371h16.868V10.94H15.169V15.371z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 16.74,
    y: 1.939,
    fill: "#FFE0AE",
    width: 13.725,
    height: 7.062
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.466,10.94H16.74c-1.071,0-1.939-0.868-1.939-1.939V1.939C14.801,0.868,15.669,0,16.74,0h13.726 c1.071,0,1.939,0.868,1.939,1.939v7.062C32.404,10.072,31.537,10.94,30.466,10.94z M18.679,7.062h9.848V3.877h-9.848V7.062z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.466,10.94H16.74c-1.071,0-1.939-0.868-1.939-1.939V1.939C14.801,0.868,15.669,0,16.74,0h13.726 c1.071,0,1.939,0.868,1.939,1.939v7.062C32.404,10.072,31.537,10.94,30.466,10.94z M18.679,7.062h9.848V3.877h-9.848V7.062z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.36,41.184h-1.894c-1.071,0-1.939-0.868-1.939-1.939s0.868-1.939,1.939-1.939h1.894c1.071,0,1.939,0.868,1.939,1.939 S18.431,41.184,17.36,41.184z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.783,41.184h-1.798c-1.071,0-1.939-0.868-1.939-1.939s0.868-1.939,1.939-1.939h1.798c1.071,0,1.939,0.868,1.939,1.939 S32.854,41.184,31.783,41.184z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.938,
    y: 63.56,
    fill: "#FFFEFE",
    width: 43.329,
    height: 30.506
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.267,96.005H1.939C0.868,96.005,0,95.137,0,94.067V63.56c0-1.071,0.868-1.939,1.939-1.939h43.328 c1.071,0,1.939,0.868,1.939,1.939v30.506C47.206,95.137,46.338,96.005,45.267,96.005z M3.877,92.128h39.451V65.499H3.877V92.128z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#71638C",
    cx: 17.22,
    cy: 73.265,
    r: 4.198
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#71638C",
    cx: 29.985,
    cy: 73.265,
    r: 4.173
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#71638C",
    cx: 23.603,
    cy: 84.362,
    r: 4.179
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.502,107.971h-5.798c-1.071,0-1.939-0.868-1.939-1.939c0-1.071,0.868-1.939,1.939-1.939h5.798 c1.071,0,1.939,0.868,1.939,1.939C28.44,107.103,27.573,107.971,26.502,107.971z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.524,
    y: 17.405,
    fill: "#FFFEFE",
    width: 16.215,
    height: 11.817
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.677,31.161H13.585V15.467h20.092V31.161z M17.463,27.283h12.337v-7.939H17.463V27.283z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlcoholSvgrepoCom);
export default __webpack_public_path__ + "static/media/alcohol-svgrepo-com.5c2cd29870a260ba2345887b69a1b9ea.svg";
export { ForwardRef as ReactComponent };